// GENERATED FILE — do not edit by hand.
// Overwritten at build time by scripts/generate-version.js.
export const APP_VERSION = '70372e5c9393ea70358847bf975987d46323d73e';
export const BUILD_NUMBER = '274';
export const BUILD_TIMESTAMP = '2026-10-21T22:38:13.662Z';
